module.exports = __webpack_public_path__ + "img/beaming_face_with_smiling_eyes.85056f8b.gif";